import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Box, Select,
  FormControl, InputLabel,MenuItem,Divider,Checkbox
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Swal from "sweetalert2";
import { useAuth } from "../../../../AuthProvider";


import { ListItemIcon, Menu,ListItemText} from "@mui/material"; 
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { useLocation } from "react-router-dom";
import { Class } from "@mui/icons-material";

function TotalBusAttendanceList() {
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [busNumber, setbusNumber] = useState([]);
  const [selectedBus, setSelectedBus] = useState("");
  const [selectedBusNoPlate, setSelectedBusNoPlate] = useState("");
 
  const [dialogbtnloading, setDialogbtnloading] = useState(false); // State for loading
  
  const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const navigate = useNavigate();
  const { oId,userId,role,pId,board } = useAuth();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { state } = useLocation();
  const principalId = state?.PrincipalId;
  const PrincipalId = pId || principalId;


//delete dialog states
const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
const [deleteTarget, setDeleteTarget] = useState(null);
const [confirmChecked, setConfirmChecked] = useState(false);

const [exportAnchorEl, setExportAnchorEl] = useState(null);
const isExportMenuOpen = Boolean(exportAnchorEl);


 const [tableLoading, setTableLoading] = useState(true);
//SSC states
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  // const [sscSelectedSection, setSscSelectedSection] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");

  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  // const [interSelectedClass, setInterSelectedClass] = useState("");
  // const [interSelectedSection, setInterSelectedSection] = useState('');
  const [interSelectedClass, setInterSelectedClass] = useState("");
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");

  const [romanNumberClass, setRomanNumberClass] = useState("");
   const [dialogcourse, setDialogCourse] = useState("");

   const [villageOptions, setVillageOptions] = useState([]);
  const [selectedVillage, setSelectedVillage] = useState("");


  const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
  console.log("selected mode :"+mode);
  const [sscClassSectionMap, setSscClassSectionMap] = useState({});
  const [hasFetchedOnce, setHasFetchedOnce] = useState(false); // new flag

        
        const handleExportClick = (event) => {
          setExportAnchorEl(event.currentTarget);
        };
        
        const handleExportClose = () => {
          setExportAnchorEl(null);
        };
  

  const handleAddNew = () => {
    navigate("/StudentsAddBusList/BusList");
  };

   const [adminusers, setadminUsers] = useState([]);
    const [selectedadminUsers, setSelectedadminUsers] = useState("");
  
    console.log("Selected admin:",selectedadminUsers);
  
     useEffect(() => {
      const fetchUsers = async () => {
          try {
              const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
              if (!response.ok) {
                  throw new Error('Failed to fetch users');
              }
              const data = await response.json();
              setadminUsers(data);
              if (data.length > 0) {
                setSelectedadminUsers(data[0].userId); // ✅ Set first record's userId as default
            }
          } catch (error) {
              console.error('Error fetching users:', error);
          }
      };
 
  
      fetchUsers();
    
  }, []);



  const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState('');
    const isPrincipal = role?.startsWith("PRINCIPAL") || false;
    const UserId = userId || selectedUsers;
    
   
      const fetchUsers = async () => {
          try {
              const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`);
              if (!response.ok) {
                  throw new Error('Failed to fetch users');
              }
              const data = await response.json();
              setUsers(data);
              if (data.length > 0) {
                setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
            }
          } catch (error) {
              console.error('Error fetching users:', error);
          }
      };

    useEffect(() => {
    if (isPrincipal) {
        fetchUsers();
    }
}, []);



 useEffect(() => {
  const fetchData = async () => {
    if (!UserId) return;
    try {
      const response = await fetch(
        `${baseUrl}/api/SchedulingRoute/bus-numbers/${oId}/${UserId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      console.log("Fetched Data:", data);

      setbusNumber(data); // save array of objects
      if (data.length > 0) {
        setSelectedBus(data[0].busNumber); // store first object as default
       setSelectedBusNoPlate(data[0].busNumberPlate); // store first object as default
      }
      setSscSelectedClass("");

    } catch (error) {
      console.error("Error fetching Bus Numbers:", error);
    }
  };

  fetchData();
}, [UserId]);


 

  //fetch student list with bus
    const fetchData = async () => {
      if (!selectedBus) {
        setLoading(false); // Ensure loading state is removed if no bus is selected
        return; 
      }
      setLoading(true);
      try {
        const response = await fetch(`${baseUrl}/api/StudentBusList/getAll/${selectedBus}/${oId}`);
        const data = await response.json();
        console.log("API Response:", data);

       // If response is not ok or data is not an array/object as expected
        if (!response.ok || !data || data.length === 0) {
          setFilteredData([]); // Clear the list on empty response
        } else {
          // ✅ Class Order from Nursery to 10
      const classOrder = [
        "Nursery", "LKG", "UKG",
        "I", "II", "III", "IV", "V",
        "VI", "VII", "VIII", "IX", "X"
      ];
       
      const normalizeClass = (cls) => {
        if (!cls) return "";
        return cls.replace("Class-", "").trim().toUpperCase();
      };

      const sortedData = [...data].sort((a, b) => {
        const classA = normalizeClass(a.romanNumberClass);
        const classB = normalizeClass(b.romanNumberClass);
        return classOrder.indexOf(classA) - classOrder.indexOf(classB);
      });
          setFilteredData(sortedData);

          // Extract unique villages
        const villages = [
          ...new Set(
            data
              .map(item => item.studentPickupLocation)
              .filter(Boolean)
          )
        ];
        setVillageOptions(villages);
        

        }

      } catch (error) {
        setFilteredData([]);
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
   
      fetchData();
 
  }, [selectedBus,oId]);


  // Filter data based on searchQuery
// const filteredResults = filteredData.filter((item) => {
//   const studentFirstName = item.studentFirstName ? item.studentFirstName.toLowerCase() : "";
//   const studentLastName = item.studentLastName ? item.studentLastName.toLowerCase() : "";
//   const fullName = `${studentFirstName} ${studentLastName}`; // Combine first and last names
//   return fullName.includes(searchQuery.toLowerCase()); // Search in full name
// });

// const filteredResults = filteredData.filter((item) => {
//   const studentFirstName = item.studentFirstName?.toLowerCase() || "";
//   const studentLastName = item.studentLastName?.toLowerCase() || "";
//   const fullName = `${studentFirstName} ${studentLastName}`;
//   return fullName.includes(searchQuery?.toLowerCase() || "");
// });

const filteredResults = filteredData.filter((item) => {
  const studentFirstName = item.studentFirstName?.toLowerCase() || "";
  const studentLastName = item.studentLastName?.toLowerCase() || "";
  const fullName = `${studentFirstName} ${studentLastName}`;

  const matchesName = fullName.includes(searchQuery?.toLowerCase() || "");
  const matchesVillage = selectedVillage
    ? item.studentPickupLocation === selectedVillage
    : true;

  return matchesName && matchesVillage;
});










  const handleEditClick = (row) => {
    setSelectedRow(row); // Set the selected row
    setDialogOpen(true); // Open the dialog
  };


 const [routeNumber, setrouteNumber] = useState([]);
  const [busNumbers, setBusNumbers] = useState([]);
const [stops, setStops] = useState([]);


useEffect(() => {
  const fetchData = async () => {
    if (!UserId || !oId) return;

    try {
      const response = await fetch(`${baseUrl}/api/SchedulingRoute/all-bus-routes/${oId}/${UserId}`);
      if (!response.ok) {
        console.log("Failed to fetch data");
        return;
      }

      const data = await response.json();
      const extractedBuses = (Array.isArray(data) ? data : [data]).map((item) => ({
        id: String(item.id || item.busNumber || Math.random()), // fallback id
        busNumber: item.busNumber || "Unknown Bus",
        busNumberPlate: item.busNumberPlate || "Unknown Plate", // added
        routeNumber: item.routeNumber || "Unknown Route",
      }));

      setBusNumbers(extractedBuses);
    } catch (error) {
      console.log("Failed to fetch bus data:", error);
    }
  };

  fetchData();
}, [baseUrl, UserId, oId]);


useEffect(() => {
  if (!selectedRow?.busNumber || !oId || !pId) return;

  const fetchStops = async () => {
    try {
      const res = await fetch(
        `${baseUrl}/api/SchedulingRoute/stops/bus/${selectedRow.busNumber}/${oId}/${pId}`
      );
      const data = await res.json();

      const cleanStops = data.stops
        .map((item) => item.stop)
        .map((frag) => frag.replace(/[\[\]"]/g, "").trim())
        .filter(Boolean);

      setStops(cleanStops);
    } catch (err) {
      console.error("Error fetching stops:", err);
      setStops([]);
    }
  };

  fetchStops();
}, [selectedRow?.busNumber, oId, pId]);

const handleBusChange = (e) => {
  const selectedBusNumber = e.target.value;
  const selectedBus = busNumbers.find((bus) => bus.busNumber === selectedBusNumber);

  setSelectedRow((prev) => ({
    ...prev,
    busNumber: selectedBusNumber,
    routeNumber: selectedBus?.routeNumber || "",
    studentPickupLocation: "", // reset pickup location if bus changes
  }));
};






   const handleSaveChanges = async () => {
   
     console.log("Selected Row Data before update:", selectedRow);
     setDialogbtnloading(true); // Start loading
     try {
       const formData = new FormData();
   
       // Append each key-value pair to FormData
       Object.keys(selectedRow).forEach((key) => {
         if (selectedRow[key] !== null && selectedRow[key] !== undefined) {
           formData.append(key, selectedRow[key]);
         }
       });
   
       // Use `selectedRow.id` instead of `rowId`
       const response = await fetch(
         `${baseUrl}/api/StudentBusList/update/${selectedRow.id}/${oId}`,
         {
           method: "PATCH",
           body: formData,
         }
       );
   
       const responseData = await response.json();
   
       if (!response.ok) {
         throw new Error(responseData.message || "Failed to update the details.");
       }
   
       toast.success("Student Bus Details updated successfully!");
       fetchData();
       // Refresh the data list
       setFilteredData((prevData) =>
         prevData.map((driver) =>
           driver.id === selectedRow.id ? { ...driver, ...selectedRow } : driver
         )
       );
   
       handleDialogClose();
     } catch (error) {
       console.error("Error updating details:", error);
       toast.error(`Error updating details: ${error.message}`);
     }finally {
      setDialogbtnloading(false); // Stop loading
    }
   };



  // const handleDeleteClick = async (row) => {
  //   if (!row.id) {
  //     toast.error("Invalid row. Please select a valid row to delete.");
  //     return;
  //   }
  
  //   // Show SweetAlert2 confirmation
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: `You Want To Delete ${row.studentFirstName} ${row.studentLastName} From the ${row.busNumber}`,
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     cancelButtonColor: "#3085d6",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         console.log("Deleting row with ID:", row.id);
  //         const response = await fetch(
  //           `${baseUrl}/api/StudentBusList/delete/${row.id}/${oId}`,
  //           {
  //             method: "DELETE",
  //           }
  //         );
  
  //         if (!response.ok) {
  //           throw new Error("Failed to delete the row. Please try again.");
  //         }
  
  //         toast.success(`Student deleted from ${row.busNumber} successfully!` , {
  //           autoClose: 2000, // Closes after 1 second (1000ms)
  //         });
          
  //         fetchData();
         
  
         
  //       } catch (error) {
  //         console.error("Error deleting row:", error);
  //         toast.error(`Error deleting row: ${error.message}`);
  //       }
  //     }
  //   });
  // };

 
  
  // -------------------------------------------
  //           For SSC functions
  // -------------------------------------------
  
  // ---- Fetch Class + Sections for SSC (School) ----
  const fetchClassRegistrationData = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${PrincipalId}`);
      const data = await response.json();
  
      if (response.ok && Array.isArray(data)) {
        // Group by class and merge section strings into unique values
        const classSectionMap = {};
  
        data.forEach(item => {
          const className = item.classRegistration;
          const sectionList = item.sections.split(",").map(s => s.trim());
  
          if (!classSectionMap[className]) {
            classSectionMap[className] = new Set();
          }
  
          sectionList.forEach(section => classSectionMap[className].add(section));
        });
  
        const classes = Object.keys(classSectionMap);
        setSscClassOptions(classes); // Class dropdown options
        setSscClassSectionMap(classSectionMap); // Save for section filtering later
  
        // No default selection
        setSscSelectedClass("");
        setSscSelectedSection("");
        setSscSectionOptions([]);
      }
    } catch (error) {
      console.error("Error fetching SSC data:", error);
    }
  };
  
  
  
   //fetch students data with bus filter with class, section
  
  // ---- Fetch Table Data for SSC ----
  const fetchClassSectionTableData = async () => {
    if (!sscSelectedClass || !sscSelectedSection) {
      setFilteredData([]);
      // setOriginalData([]);
      setTableLoading(false);
      return;
    }
    setTableLoading(true);
    try {
      const response = await fetch(
        `${baseUrl}/api/StudentBusList/getAllClassAndSectionWise/${pId}/${oId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`
      );
      const data = await response.json();
      if (response.ok) {
        // setOriginalData(data);
        setFilteredData(data || []);
        // setFilteredData(data.feePayments || []);
        // setUniqueCourseType([...new Set(data.map(item => item.course))]);
      } else {
        // setOriginalData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching SSC table data:", error);
    } finally {
      setTableLoading(false);
    }
  };
  
  
  
  
  // -------------------------------------------
  //           For Intermediate functions
  // -------------------------------------------
  
  // ---- Fetch Courses for INTERMEDIATE ----
  const fetchCourseData = async () => {
    if(!interSelectedClass) return;
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${PrincipalId}?romanNumberClass=${interSelectedClass}`);
      const data = await response.json();
      if (response.ok && Array.isArray(data)) {
        setCourseOptions(data);
        // if (!selectedCourseType) {
        //   setSelectedCourseType("");
        // }
      } else {
        setCourseOptions([]);
      }
    } catch (error) {
      console.error("Error fetching course data:", error);
      setCourseOptions([]);
    }
  };
  
  // ---- Fetch Sections for INTERMEDIATE ----
  
  const fetchSectionsData = async () => {
    if (!interSelectedClass || !selectedCourseType) {
      setInterSectionOptions([]);
      setInterSelectedSection("");
      return;
    }
  
    try {
      const response = await fetch(
        `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${PrincipalId}`
      );
      const data = await response.json();
  
      if (response.ok && Array.isArray(data) && data.length > 0) {
        const sectionsString = data[0].sections || "";
        const sections = sectionsString
          .split(",")
          .map((section) => section.trim());
  
        setInterSectionOptions(sections);
        setInterSelectedSection(sections[0] || "");
      } else {
        setInterSectionOptions([]);
        setInterSelectedSection("");
      }
    } catch (error) {
      console.error("Error fetching INTERMEDIATE section data:", error);
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  };
  
  
  
  
  
  
  // ---- Fetch Table Data for INTERMEDIATE ----
  const fetchCourseClassSectionTableData = async () => {
    if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
      setFilteredData([]);
      // setOriginalData([]);
      setTableLoading(false);
      return;
    }
    setTableLoading(true);
    try {
      const response = await fetch(
        `${baseUrl}/api/feePayment/adm/getAllfeePayments/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&rolePayment=tution_fee`
        
      );
      const data = await response.json();
      if (response.ok) {
        // setOriginalData(data);
        setFilteredData(data.feePayments || []);
        // setUniqueCourseType([...new Set(data.map(item => item.course))]);
      } else {
        // setOriginalData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching INTERMEDIATE table data:", error);
      setFilteredData([]);
    } finally {
      setTableLoading(false);
    }
  };
  
  
  
  
  useEffect(() => {
    if (board === "INTERMEDIATE") {
      fetchSectionsData();
    } else if (board === "SSC") {
      fetchClassRegistrationData();
    }
  }, [board, interSelectedClass, selectedCourseType, oId]);
  
  // SSC: When selected class changes, update its sections
  // useEffect(() => {
  //   const updateSectionOptions = async () => {
  //     try {
  //       const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}`);
  //       const data = await response.json();
  //       if (response.ok && Array.isArray(data)) {
  //         const selectedClassData = data.find(item => item.classRegistration === sscSelectedClass);
  //         if (selectedClassData) {
  //           const sections = selectedClassData.sections.split(",");
  //           setSscSectionOptions(sections);
  //           setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
  //         } else {
  //           setSscSectionOptions([]);
  //           setSscSelectedSection("");
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error updating SSC sections:", error);
  //     }
  //   };
  
  //   if (board === "SSC" && sscSelectedClass) {
  //     updateSectionOptions();
  //   }
  // }, [sscSelectedClass, board, oId]);
  
  // INTERMEDIATE: When class or course type changes, update sections
  useEffect(() => {
    const updateIntermediateSections = async () => {
      if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
        await fetchSectionsData();
      }
    };
    updateIntermediateSections();
  }, [interSelectedClass, selectedCourseType, board]);
  
  
  
  // Fetch course options if board is INTERMEDIATE
  useEffect(() => {
    if (board === "INTERMEDIATE") {
      fetchCourseData();
    }
  }, [interSelectedClass,board, oId]);
  
  // Fetch Table Data whenever filters change
  // useEffect(() => {
  //   if (board === "SSC") {
  //     if (!sscSelectedClass || !sscSelectedSection) {
  //       setFilteredData([]);
  //       setTableLoading(false); // ✅ stop loading even if API not called
  //       return;
  //     }
  //     fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
  //   } else if (board === "INTERMEDIATE") {
  //     if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
  //       setFilteredData([]);
  //       setTableLoading(false); // ✅ same here
  //       return;
  //     }
  //     fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
  //   }
  // }, [board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);
  
  useEffect(() => {
    const fetchData = () => {
      if (board === "SSC") {
        if (sscSelectedClass && sscSelectedSection && mode === "classSection") {
          fetchClassSectionTableData();
        } else {
          setFilteredData([]);
          setTableLoading(false);
        }
      } else if (board === "INTERMEDIATE") {
        if (selectedCourseType && interSelectedClass && interSelectedSection && mode === "classSection") {
          fetchCourseClassSectionTableData();
        } else {
          setFilteredData([]);
          setTableLoading(false);
        }
      }
    };
  
    fetchData();
  }, [board, sscSelectedClass, sscSelectedSection, selectedCourseType, interSelectedClass, interSelectedSection, mode]);
  





const handleOpenDeleteDialog = (row) => {
  setDeleteTarget(row);
  setConfirmChecked(false); // Reset checkbox
  setOpenDeleteDialog(true);
};


const confirmDelete = async () => {
  if (!deleteTarget) return;

  try {
    const res = await fetch(`${baseUrl}/api/StudentBusList/delete/${deleteTarget.id}/${oId}`, {
      method: 'DELETE',
    });

    if (!res.ok) {
      throw new Error("Failed to delete the row. Please try again.");
    }

    toast.success(`Student deleted from ${deleteTarget.busNumber} successfully!`, {
      autoClose: 1000,
      position: "top-right",
    });

    setOpenDeleteDialog(false);
    fetchData(); // Refresh data
  } catch (error) {
    // toast.error(`Error deleting row: ${error.message}`);
    toast.error(`${error.message}`, {
      autoClose: 2000,
      position: "top-right",
    });
    console.error('Delete error:', error);
  }
};








  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };

  const dataCellStyle = { 
    textAlign: "center", 
    borderRight: "1px solid #ddd", 
    padding: "2px" 
  };

     // Export to Excel
     const exportToExcel = () => {
      const filteredData = filteredResults.map(
        ({
          studentFirstName,
          studentLastName,
          gender,
          romanNumberClass,
          sections,
          busNumberPlate,
          routeNumber,
          busTotalFee,
          distance,
          studentPickupLocation,
          studentDropLocation,
          fatherName,
          fatherPhoneNumber,
        }) => ({
          Name: `${studentFirstName} ${studentLastName}`, // Full Name
          Gender: gender||"N/A",
 Class: romanNumberClass,
  Section: sections,
          BusNumber: busNumberPlate,
          RouteNumber: routeNumber,
          BusTotalFee: busTotalFee,
          Distance: distance,
          StudentPickupLocation: studentPickupLocation,
          StudentDropLocation: studentDropLocation,
          FatherName: fatherName||"N/A",
          FatherPhoneNumber: fatherPhoneNumber,
        })
      );
    
      const workbook = new ExcelJS.Workbook();
      // const worksheet = workbook.addWorksheet(`${selectedBus}_Students_List`);

         const worksheet = workbook.addWorksheet(
            (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
              ? `${interSelectedClass}-${interSelectedSection}_Students_List`
              : (board === "SSC" && sscSelectedClass && sscSelectedSection)
                ? `${sscSelectedClass}-${sscSelectedSection}_Students_List`
                : `${selectedBusNoPlate}_Students_List`
          );
    
      // Add headers
      worksheet.columns = [
        { header: "Student Name", key: "Name", width: 20 },
        { header: "Gender", key: "Gender", width: 10 },
        { header: "Class", key: "Class", width: 10 },
        { header: "Section", key: "Section", width: 10 },
        { header: "Bus No", key: "BusNumber", width: 15 },
        { header: "Route No", key: "RouteNumber", width: 15 },
        { header: "Total Fee", key: "BusTotalFee", width: 15 },
        { header: "Distance", key: "Distance", width: 15 },
        { header: "Pickup Location", key: "StudentPickupLocation", width: 20 },
        // { header: "Drop Location", key: "StudentDropLocation", width: 20 },
        { header: "Father Name", key: "FatherName", width: 20 },
        { header: "Father Phone No", key: "FatherPhoneNumber", width: 20 },
      ];
    
      // Add data rows
      filteredData.forEach((data) => {
        worksheet.addRow(data);
      });
    
      // Style headers
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "87CEEB" }, // Light Blue Header
        };
      });
    
      // Write and download file
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        // link.download = `${selectedBus}_Students_List.xlsx`;

         link.download = (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
        ? `${interSelectedClass}-${interSelectedSection}_Students_List.xlsx`
        : (board === "SSC" && sscSelectedClass && sscSelectedSection)
          ? `${sscSelectedClass}-${sscSelectedSection}_Students_List.xlsx`
          : `${selectedBusNoPlate}_Students_List.xlsx`;
        link.click();
      });
    
      handleExportClose();
    };
    
     
     // Export to PDF
  const exportToPDF = () => {
      const doc = new jsPDF();
    
      // Title
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      // doc.text(`${selectedBus} Students List`, 10, 8);

      if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
              doc.text(`${interSelectedClass}-${interSelectedSection}Students List`, 10, 8);
            } else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
              doc.text(`${sscSelectedClass}-${sscSelectedSection} Students List`, 10, 8);
            } else {
               doc.text(`${selectedBusNoPlate} - Students List`, 10, 8);
            }
    
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text("Generated On: ", 10, 16);
      doc.setFont("helvetica", "bold");
      doc.text(new Date().toLocaleDateString(), 36, 16);
    
      // Table
      doc.autoTable({
        startY: 20,
         margin: { top: 0, left: 3, right: 3 }, 
        head: [
          [
            "S.No",
            "Student Name",
            // "Gender",
            "Bus No",
            "Route No",
            "Total Fee",
            "Distance",
            "Pickup Location",
            // "Drop Location",
            "Father Name",
            "Father Phone No",
          ],
        ],
        body: filteredResults.map((row, index) => [
          index + 1,
          `${row.studentFirstName} ${row.studentLastName}`, // ✅ Full Name
          // row.gender||"N/A",
          row.busNumberPlate,
          row.routeNumber,
          row.busTotalFee,
          row.distance,
          row.studentPickupLocation || "N/A",
          // row.studentDropLocation,
          row.fatherName||"N/A",
          row.fatherPhoneNumber,
        ]),
        styles: {
          lineWidth: 0.2,
          lineColor: "#B6B9CD",
        },
        headStyles: {
          fillColor: [63, 81, 181], // Dark Blue Header
          textColor: [255, 255, 255],
          halign: "center",
        },
        bodyStyles: {
          halign: "center",
        },
        theme: "grid",
      });
    
      // doc.save(`${selectedBus}_Students_List.pdf`);

      if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
                doc.save(`${interSelectedClass}-${interSelectedSection}_Students_List.pdf`);
              } else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
                doc.save(`${sscSelectedClass}-${sscSelectedSection}_Students_List.pdf`);
              } else {
                  doc.save(`${selectedBusNoPlate}_Students_List.pdf`);
              }
      handleExportClose();
    };
     
     
     // Export to JSON
     const exportToJSON = () => {
       const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
         JSON.stringify(filteredResults, null, 2)
       )}`;
       const link = document.createElement("a");
       link.href = jsonString;
       link.download = `${selectedBus}_Students_List.json`;
       link.click();
       handleExportClose();
     };
  
  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "5px 10px 10px 10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <CardContent >
        
         <Box display="flex" justifyContent="space-between" alignItems="center" sx={{marginBottom:2}}>
          <Box display="flex" alignItems="center">
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Bus Wise Students List
                              </Typography>
                              </Box>

                                  {/* Register Button */}
                                  <Button
                                    variant="contained"
                                    onClick={handleAddNew}
                                    style={{ backgroundColor: "#3C3972", fontWeight: "bold", height: "40px" }}
                                  >
                                    Register New Student
                                  </Button>
                            </Box>

        {/* Search and Add New Button Section */}
       <Grid
  container
  alignItems="center"
  justifyContent="space-between"
  spacing={2}
  style={{ marginTop: "8px", flexWrap: "nowrap" }}
>
  {/* Left Side: Search + Selects */}
  <Grid item style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
    {/* Search by Name */}
    <TextField
      label="Search by Name"
      variant="outlined"
      size="small"
      style={{ width: "150px" }}
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
    />

    {/* Select Bus */}
    <FormControl style={{ width: "150px" }} variant="outlined" size="small">
      <InputLabel id="bus-select-label" style={{ fontSize: "12px" }}>
        Select Bus
      </InputLabel>
      <Select
        labelId="bus-select-label"
        value={selectedBus}
        // onChange={(e) => setSelectedBus(e.target.value)}
          onChange={(e) => {
  // setSelectedBus(e.target.value);
     const value = e.target.value;
      setSelectedBus(value);
  // ✅ find bus object by busNumber
      const selected = busNumber.find((b) => b.busNumber === value);
      if (selected) {
        setSelectedBusNoPlate(selected.busNumberPlate || selectedBusNoPlate);
      }

      setSelectedVillage("");
      setSscSelectedClass("");
      setSscSelectedSection("")
    }}
        label="Select Bus"
        style={{ height: "35px", fontSize: "13px" }}
      >
        {busNumber.map((bus, index) => (
          <MenuItem key={index} value={bus.busNumber}>
      {bus.busNumberPlate} {/* Display Plate */}
    </MenuItem>
        ))}
      </Select>
    </FormControl>
    
            {/*select village*/}
            <FormControl style={{ width: "150px" }} variant="outlined" size="small">
  <InputLabel id="village-select-label" style={{ fontSize: "12px" }}>
    Select Village
  </InputLabel>
  <Select
    labelId="village-select-label"
    value={selectedVillage}
    onChange={(e) => setSelectedVillage(e.target.value)}
    label="Select Village"
    style={{ height: "35px", fontSize: "13px" }}
  >
    <MenuItem value="">
      <em>All Villages</em>
    </MenuItem>

    {villageOptions.map((village, index) => (
      <MenuItem key={index} value={village}>
        {village}
      </MenuItem>
    ))}
  </Select>
</FormControl>



             {board === "SSC" && (
                <>
                  <FormControl size="small" sx={{ minWidth: 120,marginRight:0}}>
                    <InputLabel id="class-select-label">Select Class</InputLabel>
                    <Select
                      labelId="class-select-label"
                      value={sscSelectedClass}
                     
              
                      onChange={(e) => {
                        const selected = e.target.value;
                        setSscSelectedClass(selected);
                        setMode("classSection");
                         setSelectedBus(""); 
                         setSelectedVillage("");

                    
                        const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
                        setSscSectionOptions(sections);
                        setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
                      }}
                      
                      label="Select Class"
                      sx={{ height: 35 }}
                    >
                      {sscClassOptions.map((cls) => (
                        <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
              {/* 
                  <FormControl size="small" sx={{ minWidth: 120}}>
                    <InputLabel id="section-select-label">Select Section</InputLabel>
                    <Select
                      labelId="section-select-label"
                      value={sscSelectedSection}
                      // onChange={(e) => setSscSelectedSection(e.target.value)}
                      onChange={(e) => {
                        setSscSelectedSection(e.target.value);
                        setMode("classSection");
                      }}
                      
                      label="Select Section"
                      sx={{ height: 35 }}
                      // disabled={sscSectionOptions.length === 0}
                    >
                      
                      {sscSectionOptions.map((section) => (
                        <MenuItem key={section} value={section}>{section}</MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                  <FormControl size="small" sx={{ minWidth: 120 ,marginRight:2}}>
                <InputLabel id="section-select-label">Select Section</InputLabel>
                <Select
                  labelId="section-select-label"
                  value={sscSelectedSection}
                  onChange={(e) => {
                    setSscSelectedSection(e.target.value);
                    setMode("classSection");
                  }}
                  label="Select Section"
                  sx={{ height: 35 }}
                >
                  {/* Show placeholder if no sections */}
                  {sscSectionOptions.length === 0 ? (
                    <MenuItem value="" disabled>
                      Select Class
                    </MenuItem>
                  ) : (
                    sscSectionOptions.map((section) => (
                      <MenuItem key={section} value={section}>
                        {section}
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
              
                </>
              )}
                  
                 {board === "INTERMEDIATE" && (
                   <>
                     <FormControl size="small" sx={{ minWidth: 120}}>
                       <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
                       <Select
                         labelId="intermediate-class-select-label"
                         value={interSelectedClass}
                         onChange={(e) => setInterSelectedClass(e.target.value)}
                         label="Select Year"
                         sx={{ height: 35 }}
                       >
                         <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
                         <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
                       </Select>
                     </FormControl>
                 
                     <FormControl size="small" sx={{ minWidth: 120}}>
                       <InputLabel id="course-type-label">Select Course</InputLabel>
                       <Select
                         labelId="course-type-label"
                         value={selectedCourseType}
                         // onChange={(e) => setSelectedCourseType(e.target.value)}
                         onChange={(e) => {
                           setSelectedCourseType(e.target.value);
                           setMode("classSection");
                         }}
                         
                         label="Select Course"
                         sx={{ height: 35 }}
                       >
                         {courseOptions.map((course, index) => (
                           <MenuItem key={index} value={course}>{course}</MenuItem>
                         ))}
                       </Select>
                     </FormControl>
                 
                    
                     <FormControl size="small" sx={{ minWidth: 120 }}>
                   <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
                   <Select
                     labelId="intermediate-section-select-label"
                     value={interSelectedSection || ""}
                     onChange={(e) => {
                       setInterSelectedSection(e.target.value);
                       setMode("classSection");
                     }}
                     label="Select Section"
                     sx={{ height: 35 }}
                   >
                     {interSectionOptions.length === 0 ? (
                       <MenuItem value="" disabled>
                         Select Year and Course
                       </MenuItem>
                     ) : (
                       interSectionOptions.map((section, index) => (
                         <MenuItem key={index} value={section}>
                           {section}
                         </MenuItem>
                       ))
                     )}
                   </Select>
                 </FormControl>
                 
                   </>
                 )}

    {/* Select Admin */}
    {/* <FormControl style={{ width: "150px" }} variant="outlined" size="small">
      <InputLabel>Select Admin</InputLabel>
      <Select
        value={selectedadminUsers}
        onChange={(e) => setSelectedadminUsers(e.target.value)}
        name="admStaffUserId"
        label="Select Admin"
      >
        {adminusers.map((user) => (
          <MenuItem key={user.userId} value={user.userId}>
            {user.userId} - {user.firstName} {user.lastName}
          </MenuItem>
        ))}
      </Select>
    </FormControl> */}

    {/* Select Transport Admin (if principal) */}
    {/* {isPrincipal && (
      <FormControl style={{ width: "150px" }} variant="outlined" size="small">
        <InputLabel>Select Transport Admin</InputLabel>
        <Select
          value={selectedUsers}
          onChange={(e) => setSelectedUsers(e.target.value)}
          label="Select Transport Admin"
        >
          {users.map((user) => (
            <MenuItem key={user.userId} value={user.userId}>
              {user.userId} - {user.firstName} {user.lastName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )} */}
  </Grid>

  {/* Right Side: Export + Register Button */}
  <Grid
    item
    style={{ display: "flex", gap: "10px", justifyContent: "flex-end", flexWrap: "nowrap" }}
  >
    {/* Export Button with Menu */}
    <div>
      <Button
        variant="contained"
        onClick={handleExportClick}
        style={{ backgroundColor: "#3C3972", fontWeight: "bold", height: "40px" }}
        startIcon={<PresentToAllIcon />}
      >
        Export
      </Button>

      <Menu
        anchorEl={exportAnchorEl}
        open={isExportMenuOpen}
        onClose={handleExportClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
          },
        }}
      >
        <MenuItem
          onClick={exportToExcel}
          sx={{ color: "#3f51b5", fontWeight: "bold", "&:hover": { backgroundColor: "#e8f0fe" } }}
        >
          <ListItemIcon sx={{ color: "#00796b" }}>
            <SimCardDownloadIcon />
          </ListItemIcon>
          <ListItemText primary="Excel" sx={{ fontWeight: "bold", color: "#00796b" }} />
        </MenuItem>

        <MenuItem
          onClick={exportToPDF}
          sx={{ color: "#d32f2f", fontWeight: "bold", "&:hover": { backgroundColor: "#fdecea" } }}
        >
          <ListItemIcon sx={{ color: "#d32f2f" }}>
            <PictureAsPdfIcon />
          </ListItemIcon>
          <ListItemText primary="PDF" sx={{ fontWeight: "bold", color: "#d32f2f" }} />
        </MenuItem>

        {/* <MenuItem
          onClick={exportToJSON}
          sx={{ color: "#388e3c", fontWeight: "bold", "&:hover": { backgroundColor: "#e8f5e9" } }}
        >
          <ListItemIcon sx={{ color: "#6a1b9a" }}>
            <FilePresentIcon />
          </ListItemIcon>
          <ListItemText primary="JSON" sx={{ fontWeight: "bold", color: "#6a1b9a" }} />
        </MenuItem> */}
      </Menu>
    </div>


  </Grid>
</Grid>




<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />
        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>S.No</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Admission No</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>{board === "INTERMEDIATE" ? "Year" : "Class"}</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Section</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Student Name</TableCell>
             
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Gender</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Address</TableCell> */}
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Bus No</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Route No</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}> Bus Total Fee</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Distance</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Pickup Location</TableCell>
                
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Father Name</TableCell> */}
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Father Email</TableCell> */}
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Village Name</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Action</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Status</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center", padding: "20px" }}>
                                          <Box display="flex" flexDirection="column" alignItems="center">
                                            <CircularProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                              Loading Data...
                                            </Typography>
                                          </Box>
                                        </TableCell>
                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow 
  key={row.id} 
  style={{
    backgroundColor: "white",
    transition: "background-color 0.3s",
    height: "40px", // Reduced row height
  }}
  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"} // Hover color
  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"} // Default color
>
  <TableCell sx={dataCellStyle}>{index + 1}</TableCell>
  <TableCell sx={dataCellStyle}>{row.customAdmissionNumber}</TableCell>
  {board === "INTERMEDIATE" && (
                                                                                                                                                              <TableCell
                                                                                                                                                                sx={dataCellStyle}
                                                                                                                                                              >
                                                                                                                                                                {row.course}
                                                                                                                                                              </TableCell>

                      )}
      <TableCell sx={dataCellStyle}>{row.romanNumberClass}</TableCell>   
       <TableCell sx={dataCellStyle}>{row.sections}</TableCell>             
  <TableCell sx={dataCellStyle}>{row.studentFirstName} {row.studentLastName}</TableCell>
  <TableCell sx={dataCellStyle}>{row.gender || "N/A"}</TableCell>
  {/* <TableCell sx={dataCellStyle}>{row.address}</TableCell> */}
  <TableCell sx={dataCellStyle}>{row.busNumberPlate}</TableCell>
  <TableCell sx={dataCellStyle}>{row.routeNumber}</TableCell>
  <TableCell sx={dataCellStyle}>₹{row.busTotalFee}</TableCell>
  {/* <TableCell sx={dataCellStyle}>{row.distance}</TableCell>
  <TableCell sx={dataCellStyle}>{row.studentPickupLocation}</TableCell>
  
  <TableCell sx={dataCellStyle}>{row.fatherName || "N/A"}</TableCell> */}
  {/* <TableCell sx={dataCellStyle}>{row.email}</TableCell> */}
  <TableCell sx={dataCellStyle}>{row.studentPickupLocation}</TableCell>
 
  <TableCell sx={{ borderRight: "1px solid #ddd", textAlign: "center", padding: "6px" }}>
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      gap: "4px",
    }}
  >
    {/* Show Edit button only if student is NOT transferred */}
    {row.studentBusStatus !== "newSchoolTransfer" && (
      <Button
        sx={{
          backgroundColor: "#1565c0",
          color: "white",
          "&:hover": { backgroundColor: "#0d47a1" },
          padding: "2px 4px",
        }}
        onClick={() => handleEditClick(row)}
      >
        Edit
      </Button>
    )}

    {/* Always show Delete button */}
    <Button
      sx={{
        backgroundColor: "#a82814",
        color: "white",
        "&:hover": { backgroundColor: "#7a1b0e" },
        padding: "4px 6px",
      }}
      // onClick={() => handleDeleteClick(row)}
      onClick={() => handleOpenDeleteDialog(row)}
    >
      Delete
    </Button>
  </Box>
</TableCell>
</TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Dialog for editing */}
        <Dialog open={isDialogOpen} onClose={handleDialogClose}>
  <DialogTitle style={{ fontWeight: "bold"}}>Edit Student Bus Details</DialogTitle>
  <DialogContent>
    <Grid container spacing={2}>
      
      {/* Student Name */}
      <Grid item xs={6}>
        <TextField
          label="Student Name"
          value={
            selectedRow ? `${selectedRow.studentFirstName || ""} ${selectedRow.studentLastName || ""}` : ""
          }
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              studentFirstName: e.target.value.split(" ")[0] || "",
              studentLastName: e.target.value.split(" ")[1] || "",
            }))
          }
          fullWidth
          margin="normal"
          disabled
          InputProps={{
            style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
          }}
        />
      </Grid>

      {/* Gender */}
      <Grid item xs={6}>
        <TextField
          label="Gender"
          value={selectedRow?.gender || ""}
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              gender: e.target.value,
            }))
          }
          fullWidth
          margin="normal"
          disabled
          InputProps={{
            style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
          }}
        />
      </Grid>




{/* Bus Number */}
<Grid item xs={6}>
<FormControl fullWidth>
  <InputLabel id="bus-select-label">Bus Number Plate</InputLabel>
  <Select
    labelId="bus-select-label"
    name="busNumber"
    value={selectedRow?.busNumber || ""} // keeps internal value as busNumber
    onChange={handleBusChange}
    label="Bus Number Plate"
    renderValue={(selected) => {
      const bus = busNumbers.find((b) => b.busNumber === selected);
      return bus ? bus.busNumberPlate : ""; // display plate
    }}
  >
    {busNumbers.length > 0 ? (
      busNumbers.map((bus) => (
        <MenuItem key={bus.id} value={bus.busNumber}>
          {bus.busNumberPlate} {/* show plate in list */}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No Buses Available</MenuItem>
    )}
  </Select>
</FormControl>


</Grid>

{/* Route Number (Read-Only) */}
<Grid item xs={6}>
  <FormControl
    fullWidth
    sx={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
  >
    <TextField
      name="routeNumber"
      value={selectedRow?.routeNumber || ""}
      label="Route No"
      InputProps={{
        readOnly: true,
        sx: {
          backgroundColor: "#e0e0e0",
          color: "#666",
          fontWeight: "bold",
          borderRadius: "5px",
          pointerEvents: "none",
          "& .MuiInputBase-input": { color: "#666", cursor: "default" },
        },
      }}
    />
  </FormControl>
</Grid>

{/* Student Pickup Location */}
<Grid item xs={6} sx={{marginTop:'5px'}}>
  <FormControl fullWidth>
    <InputLabel>Student Village Name</InputLabel>
    <Select
      name="studentPickupLocation"
      value={selectedRow?.studentPickupLocation || ""}
      onChange={(e) =>
        setSelectedRow((prev) => ({
          ...prev,
          studentPickupLocation: e.target.value,
        }))
      }
      label="Student Pickup Location"
    >
      {stops.length > 0 ? (
        stops.map((stop, idx) => (
          <MenuItem key={idx} value={stop}>
            {stop}
          </MenuItem>
        ))
      ) : (
        <MenuItem disabled>No Stops Available</MenuItem>
      )}
    </Select>
  </FormControl>
</Grid>
      <Grid item xs={6} sx={{marginTop:'-10px'}}>
        <TextField
          label="Father's Phone Number"
          value={selectedRow?.fatherPhoneNumber || ""}
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              fatherPhoneNumber: e.target.value,
            }))
          }
          InputProps={{
        readOnly: true,
        sx: {
          backgroundColor: "#e0e0e0",
          color: "#666",
          fontWeight: "bold",
          borderRadius: "5px",
          pointerEvents: "none",
          "& .MuiInputBase-input": { color: "#666", cursor: "default" },
        },
      }}
          fullWidth
          margin="normal"
        />
      </Grid>

      {/* Bus Total Fee */}
      <Grid item xs={6}>
        <TextField
          label="Bus Total Fee"
          value={selectedRow?.busTotalFee || ""}
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              busTotalFee: e.target.value,
            }))
          }
          fullWidth
          margin="normal"
        />
      </Grid>
      
    </Grid>
  </DialogContent>

  {/* Dialog Actions */}
  <DialogActions>
       <Button
         onClick={handleDialogClose}
         color="primary"
         variant="outlined"
         
       >
         Cancel
       </Button>
       
       <Button
         onClick={handleSaveChanges}
         color="primary"
         variant="contained"
         disabled={dialogbtnloading} // Disable when loading
         sx={{
          fontWeight: 600,
          backgroundColor: "#3C3972",
          "&:hover": { backgroundColor: "#3C3972" },
        }}
       >
        {dialogbtnloading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Save"}
       </Button>
  </DialogActions>
</Dialog>


{/* //delete dialog code */}
<Dialog
  open={openDeleteDialog}
  onClose={() => setOpenDeleteDialog(false)}
  maxWidth="xs"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 3,
      p: 2,
      boxShadow: 6,
    },
  }}
>
  {/* Icon */}
  <Box display="flex" justifyContent="center" mt={1}>
    <Box
      sx={{
        backgroundColor: '#fff3cd',
        borderRadius: '50%',
        width: 64,
        height: 64,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // mb: 1,
        border: '2px solid #f5c2c7',
      }}
    >
      <Typography variant="h4" color="warning.main">!</Typography>
    </Box>
  </Box>

  {/* Title */}
  <DialogTitle
    sx={{
      textAlign: 'center',
      fontSize: '17px',
      fontWeight: 600,
      // mb: 1,
      px: 3,
    }}
  >
    Are you sure you want to delete this student{' '}
    <span style={{ color: '#d32f2f', fontWeight: 700 }}>
      {deleteTarget?.studentFirstName?.toUpperCase()} {deleteTarget?.studentLastName?.toUpperCase()}
    </span>?
  </DialogTitle>

  <Divider variant="middle" />

  {/* Content */}
  <DialogContent sx={{ fontSize: '12px', px: 3 }}>
    <p style={{ marginBottom: 8 }}>
      Deleting this student will also <strong>permanently</strong> remove all related data:
    </p>
    <ul style={{ marginLeft: 20, paddingLeft: 10 }}>
      <li>✅ <strong>Student Bus Registration data</strong></li>
      {/* <li>✅ <strong>Bus Fee Payments history</strong></li> */}
      <li>✅ <strong>Student Bus Attendance records</strong></li>
    </ul>

    {/* Confirmation Checkbox */}
    <Box display="flex" alignItems="center" mt={2}>
  <Checkbox
    checked={confirmChecked}
    onChange={(e) => setConfirmChecked(e.target.checked)}
    sx={{
      // color: 'error.main',
      p: 0.5, // reduce padding to avoid vertical misalignment
      mr: 1.2, // add right margin for spacing between checkbox and text
    }}
  />
  <Typography
    variant="body2"
    sx={{
      color: 'error.main',
      fontWeight: 'bold',
      whiteSpace: 'nowrap', // optional: prevent wrapping
    }}
  >
    Once deleted, this information cannot be recovered.
  </Typography>
</Box>

  </DialogContent>

  {/* Actions */}
  <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
    <Button
      onClick={() => setOpenDeleteDialog(false)}
      color="primary"
      variant="outlined"
      fullWidth
    >
      Cancel
    </Button>
    <Button
      onClick={confirmDelete}
      color="error"
      variant="contained"
      fullWidth
      disabled={!confirmChecked}
    >
      Yes, delete everything!
    </Button>
  </DialogActions>
</Dialog>
  <ToastContainer position="top-right" autoClose={2000}  />
      </CardContent>
    </Card>
  );
}

export default TotalBusAttendanceList;